<template>
  <!-- TODO OrderProducts template -->
  <div class="container has_table">
    <div class="table_body adds_product_table" style="padding-top: 20px">
      <div class="top_table flx">
        <h3>Список товаров</h3>
        <div class="info_sum flx">
          <div class="item flx" v-if="total > 0">
            <span class="grey">Сумма дроп:  </span>
            <span>{{ getTotal() }} грн</span>
          </div>
          <div class="item flx" v-if="pay_type !== 1 && sender_is_fop">
            <span>Укажите сумму продажи в чеке :<span class="red">*</span></span>
            <div class="inp_wrap">
              <input type="text" v-model.number="totalCheck" :class="{required: hasError('total_check')}">
            </div>
          </div>
          <div class="item flx" v-else>
            <span>Укажите цену продажи:<span class="red">*</span></span>
            <div class="inp_wrap">
              <input type="text" v-model.number="totalFinal" :class="{required: hasError('total_final')}">
            </div>
          </div>
        </div>
      </div>
      <div class="wrap_tbl">
        <div class="headline_table flx">
<!--          <label class="custom-checkbox">-->
<!--            <input type="checkbox" name="remembered" value="remembered">-->
<!--            <span></span>-->
<!--          </label>-->
          <div class="img_prod">
            <p>Фото</p>
          </div>
          <div class="name_prod">
            <p>Название</p>
          </div>
          <div class="category_prod">
            <p>Категория</p>
          </div>
          <div class="size_prod">
            <p>Размер</p>
          </div>
          <div class="characteristic_prod">
            <p>Характеристики</p>
          </div>
          <div class="discount_prod">
            <p>Скидка</p>
          </div>
          <div class="quantity_prod">
            <p>Кол-во</p>
          </div>
          <div class="sum_drop_prod">
            <p>Сумма (дроп) со скидкой</p>
          </div>
          <div class="cross"> </div>
        </div>
        <div class="row_list">
          <div class="row flx" v-for="item in order_products" :key="'order_product-'+item.product_color_size_id">
            <div class="img_prod">
              <img style="object-fit: cover" :src="item.image_url[60]" :alt="item.name" :title="item.name" v-if="item.image_url">
              <img v-else style="object-fit:cover" src="/images/no-img.svg" alt="">
            </div>
            <div class="name_prod">
              <p>{{ item.name }}</p>
            </div>
            <div class="category_prod">
              <p class="grey">{{ item.category_name }}</p>
            </div>
            <div class="size_prod">
              <brew-select
                label="size_name"
                :options="item.size_variant"
                class=""
                :value="item.size"
                :clearable="false"
                @option:selected="changeProduct($event, item.id)"
                :selectable="option => option.remains > 0 && !order_products.find(p => option.product_color_size_id === p.product_color_size_id)"
              >
              </brew-select>
<!--              <select name="/" @change="changeProduct($event, item.id)">-->
<!--                <option :value="size" v-for="size in item.size_variant" :key="item.product_color_size_id+size.size_id">{{ size.size_name }}</option>-->
<!--              </select>-->
              <span :class="getColorRemains(item.remains)">{{ item.remains ? item.remains : '' }} шт</span>
            </div>
            <div class="characteristic_prod">
              <div class="item flx">
                <span>Артикул:</span>
                <span class="line"> </span>
                <p>{{ item.vendor_code }}</p>
              </div>
              <div class="item flx">
                <span>Размер:</span>
                <span class="line"> </span>
                <p>{{ item.size }}</p>
              </div>
              <div class="item flx">
                <span>Цвет:</span>
                <span class="line"> </span>
                <p>{{ item.color }}</p>
              </div>
              <div class="item flx">
                <span>Вес:</span>
                <span class="line"> </span>
                <p>{{ item.weight }}</p>
              </div>
            </div>
            <div class="discount_prod">
              <span v-if="item.discount">{{ item.discount.value }}{{ item.discount.type}}</span>
              <span v-else>0%</span>
            </div>
            <div class="quantity_prod">
              <input type="number" :value="item.qty" min="1" :max="item.remains" @input="setOrderProductQty($event, item)">
            </div>
            <div class="sum_drop_prod">
              <p v-if="item.discount">{{ item.retail_price * item.qty - item.discount.total * item.qty | asPrice }}</p>
              <p v-else>{{ item.retail_price * item.qty | asPrice }}</p>
            </div>
            <div class="cross close" @click="deleteCart(item.id)"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
import { colors } from '../../../mixins/colors'
import { prices } from '../../../mixins/prices'
import BrewSelect from '../../../helpers/components/BrewSelect'

export default {
  name: 'OrderProducts',
  mixins: [prices, colors],
  props: ['pay_type'],
  components: {
    BrewSelect
  },
  computed: {
    ...mapState('cart', ['carts', 'total', 'cart_counts', 'total_final', 'total_check', 'sender_is_fop']),
    ...mapGetters('cart', ['getTotal']),
    ...mapGetters('errors', ['hasErrors', 'hasError']),
    totalFinal: {
      get () {
        return this.total_final
      },
      set (val) {
        this.setTotalFinal(val)
      }
    },
    totalCheck: {
      get () {
        return this.total_check
      },
      set (val) {
        this.setTotalCheck(val)
      }
    },
    order_products: {
      get () {
        return this.carts
      },
      set (val) {
        this.setCartItems(val)
      }
    }
  },
  methods: {
    ...mapMutations('cart', ['setTotalFinal', 'setTotalCheck', 'setCartItems']),
    ...mapActions('cart', ['deleteCart', 'addItemToCart']),
    setOrderProductQty (e, product) {
      product.qty = e.target.valueAsNumber
      const index = this.order_products.findIndex(p => p.product_color_size_id === product.product_color_size_id)
      this.$set(this.order_products, index, product)
    },
    changeProduct (e, id) {
      this.deleteCart(id)
      e.qty = 1
      this.addItemToCart(e)
    }
  },
  created () {
    this.setTotalFinal(0)
  }
}
</script>

<style scoped>

</style>
